import { Controller } from 'stimulus';

export default class LessonFeedbackController extends Controller {
  static targets = ['radioButton', 'input'];

  radioButtonTargets: HTMLInputElement[];
  inputTarget: HTMLInputElement;

  connect() {
    this.setRadioButtons();
    $(this.radioButtonTargets).on('click', (evt) => {
      evt.preventDefault();
      $(this.inputTarget).val($(evt.currentTarget).data('value'));
      this.setRadioButtons();
    });
  }

  setRadioButtons() {
    const val = $(this.inputTarget).val();
    this.radioButtonTargets.forEach((radioButton) => {
      $(radioButton).toggleClass('btn-outline', $(radioButton).data('value') !== val);
    });
  }
}
